import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './35f0510518fe12f18b187d0b73c44f634770aee891e22ca3c39160ff42668804.cfe-internal.js';

var _excluded = ["size", "className", "aria-hidden"];
var IconSizes = {
  small: 16,
  medium: 24,
  large: 32
};
var createIconComponent = function createIconComponent(type, svgContent) {
  var Icon = /*#__PURE__*/forwardRef(function (_ref, ref) {
    var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      className = _ref.className,
      ariaHidden = _ref['aria-hidden'],
      rest = _objectWithoutProperties(_ref, _excluded);
    var classes = classNames(styles.icon, className);
    var pixels = IconSizes[size];
    return /*#__PURE__*/React__default.createElement("svg", _extends({}, rest, {
      className: classes,
      ref: ref,
      width: pixels,
      height: pixels,
      focusable: "false",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      "data-icontype": type,
      "aria-hidden": ariaHidden,
      dangerouslySetInnerHTML: {
        __html: svgContent
      } // eslint-disable-line react/no-danger
    }));
  });
  Icon.displayName = "".concat(type, "Icon");
  return Icon;
};

export { createIconComponent as default };
